export default "__VITE_ASSET__BhIGNlc6__"